export const initializeGA = () => {
  try {
    const environment = __ENV__;
    const measurementId = __GA_MEASUREMENT_ID__ || "";

    if (!measurementId) {
      console.log(
        `Google Analytics disabled in the ${environment} environment`,
      );
      window.gtag = function () {};
      return;
    }

    if (!document.getElementById("ga-gtag")) {
      const script = document.createElement("script");
      script.id = "ga-gtag";
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);
    }

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    window.gtag("js", new Date());
    window.gtag("config", measurementId, {
      debug_mode: environment === "local",
      environment: environment,
      send_page_view: false,
    });
  } catch (err) {
    console.error("Failed to initialize Google Analytics:", err);
  }
};

export const logPageView = (dealer_id?: string) => {
  try {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_title: document.title,
        dealership: dealer_id,
      });
    }
  } catch (err) {
    console.error("Failed to send page view to Google Analytics:", err);
  }
};
